<!-- <section class="st-intro st-combo">
    <div class="background">
        <div class="video row">
            <video #videoElement muted loop webkit-playsinline playsinline class="main_video">
              <source src="https://v615.wownet.biz/uploads/product/MEDIUSKOREA_배너(음소거).mp4" type="video/mp4">
            </video>
          </div>
    </div>
    <div class="container" hidden="true">
        <div class="content">
            <h2 class="h-large">{{ 'home-page.lbl.001' | translate }}</h2>
            <p>{{ 'home-page.lbl.002' | translate }}</p>
            <a class="w-btn rounded-btn" routerLink="/shopping-mall/category/0111">
                <span>{{ 'home-page.lbl.003' | translate }}</span>
                <div></div>
            </a>
        </div>
    </div>
</section> -->

<hp-slider  [urlWownet]="urlWownet"></hp-slider>

<board-popup></board-popup>


<hp-features  [urlWownet]="urlWownet" [lshowPdtYn] = "lshowPdtYn"></hp-features>

<div class="mainBrand">
  <div class="mobile-brand-img"><img class="img w-100" src="../../../assets/lasted/img/heart-img-mobile.png" alt="The Heart of The World, The Core of Happiness"></div>
  <div class="contain">
    <!-- <div class="mobile-brand-img"><img class="img w-100" src="../../../assets/lasted/img/heart-img-mobile.png" alt="The Heart of The World, The Core of Happiness"></div> -->
    
        <div class="imgWrap"><img class="heart-img" src="../../../assets/lasted/img/heart-img.jpg" alt="The Heart of The World, The Core of Happiness"></div>
      <div class="txtWrap">
          <div class="row">
              <h2 class="tit-big">The Heart of The World, The Core of Happiness</h2>
              <p class="my-lg-4 my-sm-2">당신만을 위한 새로운 아름다움의 가치, <i></i>
                진정성과 신뢰로 모든 고객과 함께 성장하는<i></i>글로벌 유통 전문기업 아이엠글로벌넷으로 초대합니다.</p>
              <div class="">
                  <a href="/about/why-iam" class="btn-heart">VIEW MORE</a>
              </div>
          </div>
      </div>
  </div>
</div>

<hp-product></hp-product>

<div class="mainWrap">
  <div class="mainRnd">
      <div class="bg-unrival">
          <div class="contain">
              <div class="txtWrap col">
                  <h2 class="tit-big">All about IAM's Technology, GF Technology, Microbiome, ROS Balace</h2>
                  <p>비교할 수 없는 특별함, IAM Globalnet <i></i>
                    IAM의 최첨단 기술과 전문인력의 오랜 연구결과로 개발되고 <i></i>검증된 제품들은 세계인의 건강한 아름다움을 약속합니다.</p>
                  <!-- <a href="#none" class="mainBtn">VIEW MORE</a> -->
                  <div class="">
                      <a href="/about/how-iam" class="btn-heart">VIEW MORE</a>
                  </div>
              </div>
              <div class="imgWrap">
                <div class="imgCont">
                    <img src="../../../assets/lasted/img/mainGF2.jpg" class="" alt="All about IAM's Technology, GF Technology, Microbiome, ROS Balace">
                </div>
                </div>
          </div>
      </div>
  </div>
  <a href="/about/why-iam">
  <div class="mainRoad">
      <div class="contain">
          <h2 class="bTit text-lg-start">Road to Happiness</h2>
      </div>

      <div class="contain d-flex sub-wrap-happy">
          <dl class="text-center wrap-happiness">
              <dt><img src="../../../assets/lasted/img/health.png" class="w-auto" alt="Health and happiness"></dt>
              <dd>
                  <h2 class="dt-tit">Health and happiness</h2>
                  <p class="w-lg-50 w-100">전 세계의 모든 사람들, 특히 IAM 회원 여러분의 <i></i>건강한 아름다움과 행복을 위해 노력하겠습니다.</p>
              </dd>
          </dl>
          <dl class="text-center wrap-happiness">
              <dt><img src="../../../assets/lasted/img/trust.png" class="w-auto" alt="Trust and honesty"></dt>
              <dd>
                  <h2 class="dt-tit">Trust and honesty</h2>
                  <p class="w-lg-50 w-100">정직과 신뢰는 모든 고객과 회원을 대하는 <i></i>IAM의 가장 중요한 기준입니다.</p>
              </dd>
          </dl>
          <dl class="text-center wrap-happiness">
              <dt><img src="../../../assets/lasted/img/together.png" class="w-auto" alt="Together"></dt>
              <dd>
                  <h2 class="dt-tit">Together</h2>
                  <p class="w-lg-50 w-100">고객과 함께 성장하는 IAM의 <i></i>핵심 가치는 여러분의 행복입니다.</p>
              </dd>
          </dl>
      </div>
  </div>
</a>
</div>

<!-- <hp-register></hp-register> -->

<!-- <hp-notice [urlWownet]="urlWownet"></hp-notice> -->
